import { render, staticRenderFns } from "./automation-list.vue?vue&type=template&id=ad79afb2&scoped=true"
import script from "./automation-list.vue?vue&type=script&lang=js"
export * from "./automation-list.vue?vue&type=script&lang=js"
import style0 from "./automation-list.vue?vue&type=style&index=0&id=ad79afb2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad79afb2",
  null
  
)

export default component.exports